export default __webpack_public_path__ + "static/media/why-us-2.847b7a38.jpg";